import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';


import { environment } from '../../environments/environment';

@Injectable()
export class CustomViewService {

  constructor(private router: Router, private http: Http) { }

  getText(uri: string): Observable<any> {
    return this.http.get(uri)
      .map((res: Response) => {
        if (res.status === 200) {
          return res.text();
        }
        // ステータス200以外の場合はエラーを発生させる
        throw new Error('Get text failed.');
      })
      .catch(error => {
        // エラー発生の場合は500画面へ遷移させる
        this.router.navigate(['/error', 500]);
        return Observable.throw(500);
      });
  }
}
